import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { HiX, HiSave, HiOutlineLockClosed, HiOutlineShieldCheck } from "react-icons/hi";
import "../styles.css";

export default function ModalEditarUsuario({ visible, usuario, onClose, onGuardar }) {
  const [password, setPassword] = useState("");
  const [rol, setRol] = useState(usuario?.rol || "");
  const [error, setError] = useState(null);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    if (visible) {
      setPassword("");
      setRol(usuario?.rol || "");
      setError(null);
      setCargando(false);
    }
  }, [visible, usuario]);

  if (!visible) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!rol) {
      setError("Por favor selecciona un rol");
      return;
    }
    setCargando(true);
    setError(null);

    try {
      await onGuardar(usuario.username, password || null, rol);
      onClose();
    } catch (err) {
      setError(err.message || "Error actualizando usuario");
    } finally {
      setCargando(false);
    }
  };

  const modalContent = (
    <div className="modal-overlay" style={{ zIndex: 1100 }}>
      <div className="modal animate-fadeIn" style={{ maxWidth: '450px' }}>
        <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <h2 style={{ margin: 0 }}>Editar Usuario: <span style={{ color: 'var(--accent-primary)' }}>{usuario.username}</span></h2>
          <button className="btn-icon" onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer' }}>
            <HiX size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="form-moderno">
          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.85rem', fontWeight: 600 }}>Nueva contraseña (opcional)</label>
            <div className="input-group-modern" style={{ position: 'relative' }}>
              <HiOutlineLockClosed style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-secondary)' }} />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Deja en blanco para no cambiarla"
                style={{ width: '100%', padding: '12px 12px 12px 40px', background: 'var(--bg-main)', border: '1px solid var(--glass-border)', borderRadius: 'var(--radius-md)', color: 'var(--text-primary)' }}
              />
            </div>
          </div>

          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.85rem', fontWeight: 600 }}>Rol de usuario</label>
            <div className="input-group-modern" style={{ position: 'relative' }}>
              <HiOutlineShieldCheck style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-secondary)' }} />
              <select
                value={rol}
                onChange={(e) => setRol(e.target.value)}
                style={{ width: '100%', padding: '12px 12px 12px 40px', background: 'var(--bg-main)', border: '1px solid var(--glass-border)', borderRadius: 'var(--radius-md)', color: 'var(--text-primary)' }}
              >
                <option value="">Selecciona un rol</option>
                <option value="admin">Administrador</option>
                <option value="user">Usuario Estándar</option>
              </select>
            </div>
          </div>

          {error && <div className="login-error" style={{ marginBottom: '20px' }}>{error}</div>}

          <div className="modal-footer" style={{ marginTop: '32px', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
            <button
              type="button"
              className="btn-gestion"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn-nueva"
              disabled={cargando}
              style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <HiSave size={20} /> {cargando ? "Guardando..." : "Guardar Cambios"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}
